import helper from '../helper'

export const servicePermissions = {
  get: (token, params) => helper.get('api/v1/permissions', token, params),
  create: (token, { data }) => helper.post('api/v1/permissions', data, token)
}
